import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../enter/enter";
import Display from "../display/display";

const Salaryemp = ({userData}) => {
  const [key, setKey] = useState("enter");
  const [Datee, setDate] = useState("");
  const [EmployeeName, setEmployeeName] = useState("");
  const [jopType, setjopType] = useState("");
  const [jopTypeNumber, setjopTypeNumber] = useState("");
  const [mainSalary, setmainSalary] = useState(0);
  const [kpis, setkpis] = useState(0);
  const [deductions, setdeductions] = useState(0);
  const [net, setnet] = useState(0);
  const [borrow, setborrow] = useState(0);
  const [note, setnote] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [Eye, setEye] = useState(false);
  const [SalaryId, setSalaryId] = useState(null);

  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة المرتبات</h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3"
            >
              <Tab eventKey="enter" title="بيانات مرتب موظف">
                <Enter 

                  Datee={Datee} setDate={setDate}
                  EmployeeName={EmployeeName} setEmployeeName={setEmployeeName}
                  jopType={jopType} setjopType={setjopType}
                  jopTypeNumber={jopTypeNumber} setjopTypeNumber={setjopTypeNumber}
                  mainSalary={mainSalary} setmainSalary={setmainSalary}
                  kpis={kpis} setkpis={setkpis}
                  deductions={deductions} setdeductions={setdeductions}
                  net={net} setnet={setnet}
                  borrow={borrow} setborrow={setborrow}
                  note={note} setnote={setnote}
                  isEdit={isEdit} setIsEdit={setIsEdit}
                  Eye={Eye} setEye={setEye}
                  SalaryId={SalaryId} setSalaryId={setSalaryId}
                  userData={userData}


                />
              </Tab>
              <Tab eventKey="display" title="عرض">
                <Display 
                  Datee={Datee}
                  EmployeeName={EmployeeName}
                  jopType={jopType}
                  jopTypeNumber={jopTypeNumber}
                  mainSalary={mainSalary}
                  kpis={kpis}
                  deductions={deductions}
                  net={net}
                  borrow={borrow}
                  note={note}
                  isEdit={isEdit}
                  Eye={Eye}
                  SalaryId={SalaryId}
                  setSalaryId={setSalaryId}
                  setIsEdit={setIsEdit}
                  setDate={setDate}
                  setEmployeeName={setEmployeeName}
                  setjopType={setjopType}
                  setjopTypeNumber={setjopTypeNumber}
                  setmainSalary={setmainSalary}
                  setkpis={setkpis}
                  setdeductions={setdeductions}
                  setnet={setnet}
                  setborrow={setborrow}
                  setnote={setnote}
                  setEye={setEye}
                  userData={userData}
                  setKey={setKey}
                  
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Salaryemp;
